import { useLocation } from '@reach/router';
import { ALL_REALMS_ID } from '../utils/constants';
import { getRealmIdFromURL } from '../utils/filters';

/**
 * Resolves the current realm scope from the URL.
 *
 * The URL is the single source of truth:
 *   /realm/<n>/<sub>   → specific realm (n)
 *   anything else      → all realms (ALL_REALMS_ID)
 *
 * Components needing scope-aware queries should consume this hook instead of
 * reading `realmId` from the global store, which can lag behind the URL.
 */
export function useRealmScope() {
  const location = useLocation();
  const routeRealm = Number(getRealmIdFromURL(location));

  if (routeRealm > 0) {
    return { realmId: routeRealm, isAllRealms: false };
  }

  return { realmId: ALL_REALMS_ID, isAllRealms: true };
}
